export default "__VITE_ASSET__ZIUTI1dK__"